import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class ComunicateComponentService {
  status: any;
  constructor() { }

  header(status = 0){
    return status;
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_services/comunicate-component.service.ts